module.exports = __webpack_public_path__ + "img/2-1.f6bb7a11.svg";